<div class="row">
    <div class="col-6 col-md-10">
        <mat-form-field class="filter">
            <input
                (keyup)="applyFilter($event.target.value)"
                [value]="searchValue"
                matInput
                placeholder="Search by Group, FBO, User, ..."
            />
            <span matPrefix><i class="fa fa-search"></i></span>
        </mat-form-field>

        <mat-form-field class="account-filter">
            <mat-label>Group Status</mat-label>
            <mat-select
                [(ngModel)]="groupAccountType"
                (selectionChange)="filterChanged()"
            >
                <mat-option value="all">All</mat-option>
                <mat-option value="active">Active</mat-option>
                <mat-option value="inactive">Inactive</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="account-filter">
            <mat-label>FBO Active Status</mat-label>
            <mat-select
                [(ngModel)]="fboActiveAccountType"
                (selectionChange)="filterChanged()"
            >
                <mat-option value="all">All</mat-option>
                <mat-option value="active">Active</mat-option>
                <mat-option value="inactive">Inactive</mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field class="account-filter">
            <mat-label>FBO Account Type</mat-label>
            <mat-select
                [(ngModel)]="fboAccountType"
                (selectionChange)="filterChanged()"
            >
                <mat-option value="all">All</mat-option>
                <mat-option value="premium">Premium</mat-option>
                <mat-option value="freemium">Freemium</mat-option>
            </mat-select>
        </mat-form-field>

        <button
            (click)="mergeGroups()"
            color="warn"
            mat-flat-button
            [disabled]="selection.selected.length < 2"
        >
            <mat-icon>merge_type</mat-icon>
            Merge Groups
        </button>
    </div>

    <div class="actions col-6 col-md-2">
        <button [matMenuTriggerFor]="gridActions" mat-icon-button>
            <mat-icon
                aria-hidden="true"
                class="mat-icon material-icons"
                role="img"
                >settings</mat-icon
            >
        </button>
        <mat-menu
            #gridActions="matMenu"
            class="switch-nested-menu-left-arrows"
            xPosition="before"
        >
            <button (click)="openSettings()" mat-menu-item>Settings</button>
        </mat-menu>
    </div>
</div>
<div
    class="w-100 table-container"
    style="overflow-x: auto; position: relative"
    (scroll)="onTableScroll($event)"
>
    <table
        mat-table
        matSort
        [dataSource]="dataSource"
        multiTemplateDataRows
        class="mat-elevation-z8"
    >
        <!-- expand collaps Column icon -->
        <ng-container matColumnDef="expandIcon">
            <th mat-header-cell *matHeaderCellDef>&nbsp;</th>
            <td mat-cell *matCellDef="let element">
                <button
                    mat-icon-button
                    aria-label="expand row"
                    (click)="
                        expandedElement =
                            expandedElement === element ? null : element;
                        $event.stopPropagation()
                    "
                >
                    <mat-icon *ngIf="expandedElement !== element"
                        >keyboard_arrow_down</mat-icon
                    >
                    <mat-icon *ngIf="expandedElement === element"
                        >keyboard_arrow_up</mat-icon
                    >
                </button>
            </td>
        </ng-container>

        <!-- Checkbox Column -->
        <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                    (change)="$event ? masterToggle() : null"
                    [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()"
                    [aria-label]="checkboxLabel()"
                >
                </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
                <mat-checkbox
                    (click)="$event.stopPropagation()"
                    (change)="$event ? selection.toggle(row) : null"
                    [checked]="selection.isSelected(row)"
                    [aria-label]="checkboxLabel(row)"
                >
                </mat-checkbox>
            </td>
        </ng-container>

        <ng-container
            matColumnDef="{{ column }}"
            *ngFor="let column of dataColumns"
        >
            <th mat-header-cell *matHeaderCellDef>
                <app-table-column-filter
                    [matDataSource]="dataSource"
                    [matSort]="sort"
                    columnId="{{ column }}"
                    propertyName="{{ column }}"
                >
                    <span> {{ getColumnDisplayString(column) }} </span>
                </app-table-column-filter>
            </th>
            <td mat-cell *matCellDef="let data">
                <ng-container *ngIf="!isCustomContent(column)">
                    {{ data[column] }}
                </ng-container>
                <ng-container *ngIf="column == 'expiredFboPricingCount'">
                    <span
                        [ngClass]="{ good: isValidPricing(data) }"
                        class="status"
                    >
                        {{
                            isValidPricing(data)
                                ? "All Pricing Live"
                                : data.activeFboCount > 0
                                ? data.expiredFboPricingCount +
                                  " of " +
                                  data.activeFboCount +
                                  " Expired"
                                : "No Active FBOs"
                        }}
                    </span>
                </ng-container>
                <ng-container *ngIf="column == 'needAttentionCustomers'">
                    <span
                        [ngClass]="{ good: data.needAttentionCustomers == 0 }"
                        class="status"
                    >
                        {{ data.needAttentionCustomers }} Need Attentions
                    </span>
                </ng-container>
                <ng-container *ngIf="column == 'lastLogin'">
                    {{ data.lastLogin | date : "medium" }}
                </ng-container>
                <ng-container *ngIf="column == 'active'">
                    {{ data.active | booleanToText }}
                </ng-container>
                <ng-container *ngIf="column == 'users'">
                    {{ data.users.length }}
                </ng-container>
                <ng-container *ngIf="column == 'expiredFboAccountCount'">
                    <span
                        [ngClass]="{ good: data.expiredFboAccountCount === 0 }"
                        class="status"
                    >
                        {{
                            data.expiredFboAccountCount == 0 &&
                            data.fboCount > 0
                                ? "All Active"
                                : data.fboCount > 0
                                ? data.expiredFboAccountCount +
                                  " of " +
                                  data.fboCount +
                                  " Inactive"
                                : "No FBOs Found"
                        }}
                    </span>
                </ng-container>
                <ng-container *ngIf="column == 'actions'">
                    <span
                        [ngClass]="{ good: data.expiredFboAccountCount === 0 }"
                        class="status"
                    >
                        {{
                            data.expiredFboAccountCount == 0 &&
                            data.fboCount > 0
                                ? "All Active"
                                : data.fboCount > 0
                                ? data.expiredFboAccountCount +
                                  " of " +
                                  data.fboCount +
                                  " Inactive"
                                : "No FBOs Found"
                        }}
                    </span>
                </ng-container>
            </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>
                <button
                    (click)="addNewGroupOrFbo()"
                    [view]="'accent'"
                    beforeIcon="fa fa-plus"
                    ni-button
                >
                    Add New
                </button>
            </th>
            <td mat-cell *matCellDef="let data">
                <button
                    [matMenuTriggerFor]="menu"
                    aria-label="Group Actions"
                    clickStopPropagation
                    mat-icon-button
                >
                    <mat-icon>settings</mat-icon>
                </button>
                <mat-menu #menu="matMenu">
                    <button
                        (click)="editGroup(data)"
                        clickStopPropagation
                        mat-menu-item
                    >
                        <mat-icon>edit</mat-icon>
                        <span>Edit Group</span>
                    </button>
                    <button
                        (click)="addNewFbo(data)"
                        clickStopPropagation
                        mat-menu-item
                    >
                        <mat-icon>add</mat-icon>
                        <span>Add FBO</span>
                    </button>
                    <button
                        [disabled]="!getGroupFreemiumFbos(data.oid).length"
                        [matMenuTriggerFor]="fbosFreemiumMenu"
                        clickStopPropagation
                        mat-menu-item
                    >
                        <span>Deactivate FBO</span>
                    </button>
                    <button
                        [disabled]="!getGroupPremiumFbos(data.oid).length"
                        [matMenuTriggerFor]="fbosPremiumMenu"
                        clickStopPropagation
                        mat-menu-item
                    >
                        <span>Activate FBO</span>
                    </button>
                </mat-menu>
                <mat-menu #fbosFreemiumMenu="matMenu">
                    <button
                        (click)="deactivateAccount(fbo)"
                        *ngFor="let fbo of getGroupFreemiumFbos(data.oid)"
                        clickStopPropagation
                        mat-menu-item
                    >
                        <mat-icon>lock_person</mat-icon>
                        <span>{{ fbo.fbo }}</span>
                    </button>
                </mat-menu>
                <mat-menu #fbosPremiumMenu="matMenu">
                    <button
                        (click)="activateAccount(fbo)"
                        *ngFor="let fbo of getGroupPremiumFbos(data.oid)"
                        clickStopPropagation
                        mat-menu-item
                    >
                        <mat-icon>person</mat-icon>
                        <span>{{ fbo.fbo }}</span>
                    </button>
                </mat-menu>
            </td>
        </ng-container>

        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
        <ng-container matColumnDef="expandedDetail">
            <td
                mat-cell
                *matCellDef="let element"
                [attr.colspan]="columnsToDisplay.length"
            >
                <div
                    class="example-element-detail"
                    [class.expanded-detail]="element === expandedElement"
                    [@detailExpand]="
                        element == expandedElement ? 'expanded' : 'collapsed'
                    "
                >
                    <app-group-fbos-grid
                    [dataSource]="fboDataSourceDictionary[element.oid]"
                    [isNetworkFbo]="isNetworkFbo(element.oid)"
                    ></app-group-fbos-grid>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
        <tr
            mat-row
            *matRowDef="let element; columns: columnsToDisplay"
            class="example-element-row"
            [class.example-expanded-row]="expandedElement === element"
            (click)="manageGroup(element)"
        ></tr>
        <tr
            mat-row
            *matRowDef="let row; columns: ['expandedDetail']"
            class="example-detail-row"
        ></tr>
    </table>
    <div class="invisible">
        <mat-paginator
            (page)="(0); onPageChanged($event)"
            [length]="groupDataSource.length"
            [pageSizeOptions]="[10, 25, 50, 100]"
            [pageSize]="pageSize"
        ></mat-paginator>
    </div>
</div>